export { EMPTY_LABEL } from '~Lib/constants';
import React, { lazy } from 'react';
import ReactDOM from 'react-dom';
import { wrapLazy } from '~Components/componentGenerators/wrapLazy';
import './output.css';
var CrmReport = wrapLazy( /*#__PURE__*/lazy(function () {
  return import('./widgets/CrmReport');
}));
var RecurringOptions = wrapLazy( /*#__PURE__*/lazy(function () {
  return import('./widgets/RecurringTasks/RecurringOptions');
}));
var KanbanCategoriesAdmin = wrapLazy( /*#__PURE__*/lazy(function () {
  return import('./widgets/KanbanCategoriesAdmin/KanbanCategoriesAdmin');
}));
var Subtasks = wrapLazy( /*#__PURE__*/lazy(function () {
  return import('./widgets/Subtasks/Subtasks');
}));
var MultiSelect = wrapLazy( /*#__PURE__*/lazy(function () {
  return import('~Widgets/CrmSettingsAdmin/components/MultiSelect');
}));
var QuotesPages = wrapLazy( /*#__PURE__*/lazy(function () {
  return import('~Widgets/QuotesPages/QuotesPages');
}));
export { ReactDOM, React, Subtasks, KanbanCategoriesAdmin, RecurringOptions, CrmReport, MultiSelect, QuotesPages };